import { FormControl, Stack, TextField, Select, MenuItem, InputLabel, Accordion, AccordionSummary, AccordionDetails, OutlinedInput, Button, CircularProgress } from '@mui/material'
import React, { useContext, useEffect, useState, useCallback, useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ParentScreenCtx } from '../../../../pages/workbench_build/WorkbenchBuild';
import { useDispatch, useSelector } from 'react-redux';
// import GetDataCheckbox from './GetDataCheckbox';
import { dataSourceTypeOptions, encodingConstant } from '../../../../constants/constantList';
import { cloneDeep, debounce, isArray } from 'lodash';
import { treeActions } from '../../../../redux/slices/treeSlice';
import { eachDeep } from "deepdash-es/standalone";
import WorkflowConnectionPanel from '../Common/WorkflowConnectionPanel';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SectionHeader } from '../../Forms/SectionHeader';
import { api } from '../../../../redux/api';
import WorkflowSourceType from '../../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType';
import GetDataCheckbox from '../GetData/GetDataCheckbox';
import { validateHexByteSequence } from '../../../../utils/validate';
import { validateWorkflowItemName } from '../../../../utils/utilFunctions';
import ErrorModal from '../../Forms/FieldDataValidation/ErrorModal';
import CommonGrid from '../../../Repository/CommonGrid';
import { MoreHorizOutlined } from "@mui/icons-material";
import WorkflowSessionModal from '../../WorkflowSessionModal';

function CustomWorkflowSessionModal({ value, setValue, data }){
  const [workflowSessionModal, setWorkflowSessionModal] = useState({
    open: false,
    isFirstTime: false,
  });

  return (
    <div style={{ 
      display: "flex", 
      alignItems: "center",
      width: "100%",
      height: "100%",
      overflow: "hidden"
    }}>
      <div style={{
        flex: 1,
        paddingLeft: '10px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0
      }}>
        {data?.VALUE}
      </div>
      <Button
        style={{ 
          border: "none", 
          background: "transparent", 
          minWidth: '30px',
          width: '30px',
          padding: '4px',
          flexShrink: 0
        }}
        onClick={() =>
          setWorkflowSessionModal({ open: true, isFirstTime: true })
        }>
        <MoreHorizOutlined fontSize="small" />
      </Button>
      <WorkflowSessionModal
        valueLabel={data?.NAME || ""}
        showAccountData={true}
        showCallingWorkflow={true}
        showDateAndTime={true}
        showSystemData={true}
        showWorkflowSession={true}
        openModal={workflowSessionModal}
        setModalOpen={setWorkflowSessionModal}
        handleClose={() =>
          setWorkflowSessionModal({ open: false, isFirstTime: false })
        }
        initialValue={value || ""}
        valuesHandler={(value) => {
          setValue(value);
        }}
      />
    </div>
  );

}

function CustomTypeDropdown({ value, setValue, values }){
  const selectRef = useRef(null);

  useEffect(() => {
    if (selectRef.current) {
      selectRef.current.value = value;
    }
  }, [value]);

  if ((value === undefined || value === '') && values.length > 0) {
    value = values[0].value;
  }
  const handleClick = (event) =>{
    event.stopPropagation();
  }
  return (
    <div className="ag-fld-type-cell" style={{ width: '100%', height: '100%', padding: 0 }}>
      <select
        className="ag-cell-dropdown"
        ref={selectRef}
        name="TYPE"
        id="typeDropdown"
        value={value}
        style={{paddingLeft:'10px'}}
        onClick={handleClick}
        onChange={(e) => setValue(e.target.value)}>
        {values.map((option, key) => (
          <option key={key} value={option.value}>
            {(option.text)}
          </option>
        ))}
      </select>
    </div>
  );

}

function SendDataProperties() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const dispatch = useDispatch();
  const { account } = useSelector(state => state.queryParams)
  const { rightTree, leftTree, templateChanged } = useSelector(state => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const { translatedData } = rightTree.tree.body
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const leftSelectedNode = leftTree?.tree?.body?.selectedNode
  const { templateHeader } = useSelector(state => state.treeData.workflow.rightTree.tree)
  const wfItemId = selectedNode?.ID;
  const { ADAPTER_TYPE, REQUEST_TYPE } = selectedNode?.OUTBOUND || {}
  const [name, setName] = useState('');
  const [encoding, setEncoding] = useState('');
  const [connectionInfo, setConnectionInfo] = useState({});
  const [runOnServer, setRunOnServer] = useState('LBL_RUN_ON_ALL_ACTIVE_SERVER');
  const [runOnServerDropdownItems, setRunOnServerDropdownItems] = useState([])
  const [dataSourceType, setDataSourceType] = useState('');
  const [gridAPI, setGridAPI] = useState(null);
  const [rowData, setRowData] = useState([{ id: 0, NAME: "", VALUE: "", TYPE: "Text" }]);
  const [isDeleting, setIsDeleting] = useState(false);
  const typeOptions = [
    {text: 'Text', value: 'Text'},
    {text: 'File', value: 'File'},
  ]

  const gridOptions = {
    columnDefs: [
      {
        showDeleteIconOnly: true,
        isDeleteControl: true,
        editable: false,
        suppressMovable: true,
        lockPosition: true,
        showDeleteIcon: (data) => {
          return data.VALUE || data.NAME;
        },
        deleteHandler: (data) => {
          setIsDeleting(true);
        },
        headerClass: "first-column-header",
      },
      {
        addNewControl: true,
        addControlLabel: "Add New Key Name",
        headerName: t("COL_KEY_NAME"),
        field: "NAME",
        editable: true,
        showPlaceholder: true,
        placeholder: t("COL_KEY_NAME"),
        tooltipField: "NAME",
        tooltipComponentParams: { color: '#ececec' },
      },
      {
        headerName: t("COL_KEY_VAL"),
        field: "VALUE",
        editable: true,
        showPlaceholder: true,
        placeholder: t("COL_KEY_VAL"),
        cellRenderer: CustomWorkflowSessionModal,
        tooltipField: "VALUE",
        tooltipComponentParams: { color: '#ececec' },
      },
      {
        headerName: t("COL_TYPE"),
        field: "TYPE",
        editable: true,
        showPlaceholder: true,
        placeholder: t("COL_TYPE"),
        cellRenderer: CustomTypeDropdown,
        cellRendererParams: { values: typeOptions },
        cellEditor: "agSelectCellEditor",
        cellEditorParams: { values: ["Text", "File"] },
        tooltipField: "TYPE",
        tooltipComponentParams: { color: '#ececec' },
      },
    ],
  }
  
  const handleCellValueChanged = (event) => {
    if(event.newValue !== event.oldValue){      
      const getAllRows = () => {
        const rows = [];
        event.api.forEachNode((node) => {
          const hasName = node?.data?.NAME?.trim();
          const hasValue = node?.data?.VALUE?.trim();
          if (hasName || hasValue) rows.push(node.data);
        });
        return rows;
      };

      const allRowsData = getAllRows();
      const formData = allRowsData.reduce((acc, curr) => {
        return acc + (curr.NAME || '') + '\u001F' + (curr.VALUE || '') + '\u001F' + (curr.TYPE || 'Text') + '\u001E';
      }, '');
      
      debounceChangeHandler('FORM_DATA', formData || null);
    }
  }
  
  const FORM_DATA_DEBOUNCE_MS = 100;
  const onCellKeyDown = (params) => {
    if (params?.event?.key !== 'Tab' || params?.event?.shiftKey) return;
    const colId = params?.column?.colId;
    if (colId === 'NAME') {
      params.event.preventDefault();
      setTimeout(() => {
        params.api?.startEditingCell({ rowIndex: params.rowIndex, colKey: 'VALUE' });
      }, 0);
      return;
    }
    if (colId === 'VALUE') {
      params.event.preventDefault();
      const rowIndex = params.rowIndex;
      const api = params.api;
      setTimeout(() => {
        api?.startEditingCell({ rowIndex, colKey: 'TYPE' });
      }, FORM_DATA_DEBOUNCE_MS + 50);
    }
  };

  const onRowDataUpdated = (event) => {
    if (isDeleting) {
      requestAnimationFrame(() => {
        const getAllRows = () => {
          const rows = [];
          event.api.forEachNode((node) => {
            const hasName = node?.data?.NAME?.trim();
            const hasValue = node?.data?.VALUE?.trim();
            if (hasName || hasValue) rows.push(node.data);
          });
          return rows;
        };

        const allRowsData = getAllRows();

        const formData = allRowsData.reduce((acc, curr) => {
          return acc + (curr.NAME || '') + '\u001F' + (curr.VALUE || '') + '\u001F' + (curr.TYPE || 'Text') + '\u001E';
        }, '');
        
        debounceChangeHandler('FORM_DATA', formData || null);
        setIsDeleting(false);
      });
    }
  }
  // Get encoding options based on adapter type (matching SWT behavior)
  const encodingConstants = useMemo(() => {
    const adaptersWithEncodingBytes = [
      'BridgeGateSocket',
      'SOCKET', 
      'MQ Series',
      'BridgeGateMQSeries',
      'FILE',
      'Synchronous Response'
    ];
    
    // Create base encoding options excluding JISAutoDetect (only for GetData)
    const { JISAutoDetect, ...sendDataEncodings } = encodingConstant;
    
    if (adaptersWithEncodingBytes.includes(ADAPTER_TYPE)) {
      return { ...sendDataEncodings, ENCODING_BYTES: 'ENCODING_BYTES' };
    }
    return sendDataEncodings;
  }, [ADAPTER_TYPE]);

  const [encodingSingleByteReplace, setEncodingSingleByteReplace] = useState('');
  const [encodingDoubleByteReplace, setEncodingDoubleByteReplace] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [showError, setShowError] = useState(false);
  const [fieldToReset, setFieldToReset] = useState(null); // 'single' or 'double'
  // Name validation states
  const [nameErrorModal, setNameErrorModal] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState('');
  
  const derivedDataSourceTypeOptions = useMemo(() => {
    const options = [...dataSourceTypeOptions];
    
    // Add FORM_DATA option when ADAPTER_TYPE is HTTP and REQUEST_TYPE is POST
    if (ADAPTER_TYPE === 'HTTP') {
      options.push({ text: t('FORM_DATA'), value: 'FORM_DATA' });
    }
    
    return options;
  }, [ADAPTER_TYPE, REQUEST_TYPE]);
  
  const dataSourceTypeMenuItems = useMemo(() => {
    return derivedDataSourceTypeOptions.map((e, i) => {
      return (
        <MenuItem value={e.value} key={`${e.value}-i`}>
          {e.text}
        </MenuItem>
      )
    })
  }, [derivedDataSourceTypeOptions])

  const encodingOptions = useMemo(() => {
    return [...Object.keys(encodingConstants)].map((e, i) => {
      return (
        <MenuItem value={encodingConstants[e]} key={i}>
          {t(encodingConstants[e])}
        </MenuItem>
      );
    });
  }, [encodingConstants, t]);

  const runOnServerOptions = runOnServerDropdownItems.map((e, i) => {
    return (
      <MenuItem value={e.value} key={`${e.value}-i`}>
        {e.text}
      </MenuItem>
    )
  })
  const getGridAPI = (api) => {
    setGridAPI(api);
  };
  const adapterTypeHandlers = {
    BridgeGateSocket: (node) => ({ SYNCHRONOUS: node?.SYNCHRONOUS }),
    FILE: (node) => ({ RUN_ON_SERVER: node?.RUN_ON_SERVER }),
    SOCKET: (node) => ({ SYNCHRONOUS: node?.SYNCHRONOUS })
    // Add more adapter types and their logic here
  };
  // Parse FORM_DATA string into row data
  const parseFormData = (formDataString) => {
    if (!formDataString) {
      return [{ id: 0, NAME: "", VALUE: "", TYPE: "Text" }];
    }
    
    let decodedString = formDataString;
    try {
      decodedString = decodeURIComponent(formDataString);
    } catch (e) {
      console.warn("Failed to decode FORM_DATA string:", e);
    }
    
    const rows = decodedString
      .split("\u001E")
      .filter(Boolean)
      .map((record, i) => {
        const [NAME, VALUE, TYPE] = record.split("\u001F");
        return { 
          id: i, 
          NAME: NAME || "", 
          VALUE: VALUE || "", 
          TYPE: TYPE || "Text" 
        };
      });
    
    rows.push({ id: rows.length, NAME: "", VALUE: "", TYPE: "Text" });
    return rows;
  };

  useEffect(() => {
    if (selectedNode) {
      const encoding = selectedNode?.OUTBOUND?.ENCODING || 'DEFAULT_ENCODING';
      const extraConnectionInfo = adapterTypeHandlers[selectedNode?.OUTBOUND?.ADAPTER_TYPE]?.(selectedNode) || {};

      setName(selectedNode?.NAME || '');
      setEncoding(encoding);
      selectedNode?.connDetailUpdateFlag !== "predefined" && setConnectionInfo({ ...selectedNode?.OUTBOUND, ...extraConnectionInfo });
      setRunOnServer(selectedNode?.RUN_ON_SERVER || t('LBL_RUN_ON_ALL_ACTIVE_SERVER'))
      setDataSourceType(selectedNode?.SOURCE_TYPE || 'TRANSLATED_DATA')
      setEncodingSingleByteReplace(selectedNode?.OUTBOUND?.ENCODE_REPLACE_WITH || '')
      setEncodingDoubleByteReplace(selectedNode?.OUTBOUND?.ENCODE_REPLACE_WITH_KANJI || '')
    }
  }, [selectedNode?.key, selectedNode?.OUTBOUND?.OVERRIDE, selectedNode?.OUTBOUND?.ENCRYPTION_TYPE, selectedNode?.connDetailUpdateFlag, selectedNode?.SOURCE_TYPE]);
  
  
  useEffect(() => {
    if (dataSourceType === 'FORM_DATA') {
      if (selectedNode?.OUTBOUND?.FORM_DATA) {
        const parsedRows = parseFormData(selectedNode.OUTBOUND.FORM_DATA);
        setRowData(parsedRows);
      } else {
        setRowData([{ id: 0, NAME: "", VALUE: "", TYPE: "Text" }]);
      }
    } else if (dataSourceType && dataSourceType !== '') {
      setRowData([{ id: 0, NAME: "", VALUE: "", TYPE: "Text" }]);
    }
  }, [dataSourceType])
  
  

  useEffect(() => {
    if (templateChanged) {
      dispatch(
        treeActions.setLeftTreeContextActionValue({
          screen: "workflow",
          data: {
            name: leftTree.tree.body.selectedNode.title,
            workflowGroup: leftTree.tree.body.selectedNode.workflowGroup,
          },
        })
      );
    }
  }, [selectedNode?.key])

  useEffect(() => {
    const adapterType = selectedNode?.OUTBOUND?.ADAPTER_TYPE;
    const extraConnectionInfo = adapterTypeHandlers[selectedNode?.OUTBOUND?.ADAPTER_TYPE]?.(selectedNode) || {};

    setConnectionInfo({ ...selectedNode?.OUTBOUND, ...extraConnectionInfo })
    if (['FILE'].includes(adapterType)) {
      const options = [{ text: t('LBL_RUN_ON_ALL_ACTIVE_SERVER'), value: 'LBL_RUN_ON_ALL_ACTIVE_SERVER' }, { text: t('LBL_RUN_ON_PRIMARY'), value: 'LBL_RUN_ON_PRIMARY' }]
      dispatch(api.endpoints.getBridgegateConfig.initiate({
        account
      })).then((response) => {
        if (response && response?.data.current_state === 'SUCCESS') {
          const list = response?.data?.data?.BRIDGEGATE_CLUSTER?.COMMON_NAME_LIST?.split(',') || [];
          const formattedList = list.map((item) => ({
            value: item,
            text: item,
          }));
          setRunOnServerDropdownItems([...options, ...formattedList])
        } else {
          setRunOnServerDropdownItems(options)
        }
      })
    }
  }, [selectedNode?.OUTBOUND?.ADAPTER_TYPE])

  // update SERVICE NAME in template header when 1st Get data name changed
  const updateTemplateHeaderIfFirstGetData = (value) => {
    const firstGetDataNode = translatedData?.[0]?.children?.find(
      (node) => node.ICON_DISPLAY === "GET_DATA"
    );

    if (selectedNode?.key === firstGetDataNode?.key) {
      const updatedHeader = {
        ...cloneDeep(templateHeader),
        SERVICE: { ...templateHeader.SERVICE, NAME: value },
      };

      dispatch(treeActions.setRightTreeTemplateHeader({
        value: updatedHeader,
        screen: parentScreen,
      }));
    }
  };

  const handleConnectionDetailsChange = (value) => {
    if (value !== null) {
      // Check if 'remove' exists in the value
      if (value.remove) {
        debounceChangeHandler(null, null, null, value.remove);
        return; // Exit early if 'remove' is handled
      }
      // Check if 'add' exists in the value
      if (value.add) {
        debounceChangeHandler(null, null, value.add, null);
        return;
      }
      // To handle updates
      const entries = Object.entries(value);
      const [key, val] = entries[entries.length - 1] || [];
      submitChange(key, val)
      // debounceChangeHandler(key, val);
    }
  }

  /**
   * Function to submit a change to a selected node in the tree structure.
   * Updates the node's properties based on the provided key-value pair and dispatches actions to update the state.
   **/
  const submitChange = (key, value, bulk, removeValues, saveToRoot = false) => {
    if (!key && !removeValues && !bulk) return;
    // Clone and deeply iterate through the tree data to update the relevant node.
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if (obj?.key) {
        
        if (bulk?.SOURCE_TYPE === "TRANSLATED_DATA" && bulk?.SOURCE_WFITEM && bulk?.OUTBOUND_NAME){
          if(obj?.ICON_DISPLAY === "TRANSLATE"){
            obj.CONDITIONAL_TEMPLATE = obj?.CONDITIONAL_TEMPLATE?.map(item => {
              item.OUTBOUND_CONDITION = item?.OUTBOUND_CONDITION?.map(condition => {
                if (condition?.OUTBOUND_ID === selectedNode.OUTBOUND_ID){
                  delete condition.OUTBOUND_ID;
                }
                return condition;
              }) || [];
              return item;
            }) || [];
          }

          if (obj?.ICON_DISPLAY === "TRANSLATE" && obj?.ID === bulk?.WF_ITEM_ID){
            obj.CONDITIONAL_TEMPLATE = obj?.CONDITIONAL_TEMPLATE?.map(item => {
              item.OUTBOUND_CONDITION = item?.OUTBOUND_CONDITION?.map(condition => {
                if (condition?.OUTBOUND_NAME === bulk?.OUTBOUND_NAME){
                  condition.OUTBOUND_ID = selectedNode.OUTBOUND_ID;
                }
                return condition;
              }) || [];
              return item;
            }) || [];
          }
        }
      }
      if (obj?.key !== selectedNode?.key) return;

      if (key === "NAME") {
        obj.title = value;
        obj[key] = value;
        if (templateHeader?.hasOwnProperty('SERVICE')) {
          updateTemplateHeaderIfFirstGetData(value)
        }
      }
      else if (key === "ENCODING" || key === 'OVERRIDE') {
        if (key === 'ENCODING' && value === 'DEFAULT_ENCODING') {
          delete obj.OUTBOUND[key]
        }
        else obj.OUTBOUND[key] = value;
      }
      // While changing ADAPTER_TYPE, remove keys that are not relevant to the selected adapter
      else if (key === 'ADAPTER_TYPE') {
        // Store the previous adapter type before changing
        const prevAdapterType = obj.OUTBOUND[key];
       
        //when ADAPTER_TYPE is switched from Http then set the Data SourceType to TRANSLATED_DATA if it was FORM_DATA,
        // remove the FORM_DATA key from the OUTBOUND object 
        if(prevAdapterType === 'HTTP' && value !== 'HTTP') {
          if(obj?.OUTBOUND?.FORM_DATA && obj?.SOURCE_TYPE === 'FORM_DATA') {
             obj.SOURCE_TYPE = 'TRANSLATED_DATA';
          }
        }

        // Commented for ticket id BG-12926
        // when ADAPTER_TYPE is switched to HTTP, automatically set SOURCE_TYPE to FORM_DATA
        // if(value === 'HTTP' && prevAdapterType !== 'HTTP') {
        //   obj.SOURCE_TYPE = 'FORM_DATA';
        // }

        // Update ADAPTER_TYPE value
        obj.OUTBOUND[key] = value;

        // Get relevant keys for both previous and new adapter type
        const prevKeys = adapterBasedKeysMap[prevAdapterType] || [];
        const newKeys = adapterBasedKeysMap[value] || [];

        if (!newKeys.length) {
          console.warn(`Adapter type "${value}" is not mapped. No changes made to OUTBOUND.`);
          return;
        }

        // Define a set of properties that should always be retained
        const alwaysRetainKeys = new Set(["ADAPTER_TYPE", "ENCODING", "DONT_RETAIN_PLAIN_TEXT", "ENCRYPTION_TYPE", "ENCRYPTION_PARAM1", "RETRY_COUNT", "TIME_BEFORE_RETRY", "QOS_HTTP_CODES", "ERROR_HANDLER_ID", "ALERT", "GUARANTY_DELIVERY", "ID", "SYNCHRONOUS"]);

        // Identify common keys between old and new adapter type
        const commonKeys = prevKeys.filter((key) => newKeys.includes(key));

        // Identify which common keys should be deleted (i.e., they exist in both but should reset)
        const keysToDelete = commonKeys.filter((key) => !alwaysRetainKeys.has(key));

        // Delete properties not in the new adapter type or those marked for deletion
        Object.keys(obj.OUTBOUND).forEach((outboundKey) => {
          if ((!newKeys.includes(outboundKey) || keysToDelete.includes(outboundKey)) && !alwaysRetainKeys.has(outboundKey)) {
            delete obj.OUTBOUND[outboundKey];
          }
        });

        // Add new properties based on adapter type
        if (adapterTypeAdditionalProperties[value]) {
          Object.assign(obj.OUTBOUND, adapterTypeAdditionalProperties[value]);
        }
        
        // Add Data Stream specific properties
        if (value === "Data Stream") {
          Object.assign(obj.OUTBOUND, {
            CWF_RUN_DISTRIBUTED: "FALSE",
            CWF_WF_GROUP: leftSelectedNode?.type === 'workflowGroup' ? leftSelectedNode?.title : leftSelectedNode?.workflowGroup
          });
        }
      }

      else if (
        adapterBasedKeysMap.hasOwnProperty(ADAPTER_TYPE) &&
        adapterBasedKeysMap[ADAPTER_TYPE].includes(key)
      ) {
        // Update keys specific to adapter-based configurations in the "OUTBOUND" object.
        if (value === null && obj?.OUTBOUND?.hasOwnProperty(key)) {
          delete obj.OUTBOUND[key]
        } else {
          obj.OUTBOUND[key] = value;
          if(key === 'SYNCHRONOUS' && (ADAPTER_TYPE === 'Web Service' || ADAPTER_TYPE === 'HTTP' || ADAPTER_TYPE === 'GraphQL'))
            obj[key] = value
        }
      }
      else if (bulk) {
        for (let prop in bulk) {
          
          if(['WF_ITEM_LOCATION', 'WF_ITEM_ID', 'WFITEM', 'CALL_WORKFLOW', 'CALL_WORKFLOW_GROUP'].includes(prop)){
            if(obj?.SOURCE_TYPE !== "SESSION_DATA")
              obj.OUTBOUND[prop] = bulk[prop];
          }
          // For HTTP adapter type, SYNCHRONOUS should be updated at both OUTBOUND and parent level
          else if ((ADAPTER_TYPE === 'HTTP' || ADAPTER_TYPE === 'GraphQL') && prop === 'SYNCHRONOUS') {
            obj.OUTBOUND[prop] = bulk[prop];
            obj[prop] = bulk[prop];
          }
          else if (adapterBasedKeysMap.hasOwnProperty(ADAPTER_TYPE) && adapterBasedKeysMap[ADAPTER_TYPE].includes(prop)){
            if(bulk[prop] === null)
              delete obj.OUTBOUND[prop]
            else
              obj.OUTBOUND[prop] = bulk[prop]
          }
          else if (prop === 'OVERRIDE' || prop === 'ENCODING' || prop === 'PREDEFINED' || prop === 'ADAPTER_TYPE' || prop === "TEMPLATE" || prop === "TEMPLATE_LOCATION")
            obj.OUTBOUND[prop] = bulk[prop]
          else{
            obj[prop] = bulk[prop];
          }
          if(prop === "SOURCE_FILE_MASK" && (bulk?.[prop]?.includes('*') || bulk?.[prop]?.includes('?')) && obj?.OUTBOUND?.hasOwnProperty("FILENAME")){
            delete obj.OUTBOUND?.FILENAME;
          }
          if(prop === "SOURCE_FILE_MASK" && (bulk?.[prop]?.includes('*') || bulk?.[prop]?.includes('?')) && obj?.OUTBOUND?.hasOwnProperty("APPEND_FILE")){
            delete obj.OUTBOUND?.APPEND_FILE;
          }
          if ((bulk[prop] === null || bulk[prop] === undefined) && obj?.OUTBOUND?.hasOwnProperty(prop)) delete obj.OUTBOUND[prop];
          if (prop !== "NAME" && (bulk[prop] === null || bulk[prop] === undefined) && obj?.hasOwnProperty(prop)) delete obj?.[prop];
        }
        
      }
      else if (removeValues) {
        for (let prop in removeValues) {
          if (obj?.OUTBOUND?.hasOwnProperty(prop)) delete obj.OUTBOUND[prop]
        }
      }
      else {
        // Update other properties directly on the object.
        obj[key] = value;
        if (value === null && obj?.hasOwnProperty(key)) delete obj[key];
      }

      // Dispatch an action to update the selected node in the state.
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: obj,
        })
      );

      // If the object has children, return them for further iteration.
      if (isArray(obj?.children)) {
        return obj.children;
      }
    });

    // Dispatch an action to update the translated tree data in the state.
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };


  const debounceChangeHandler = useCallback(debounce(submitChange, 100), [rightTree.tree])

  // Handle changes to the data name, specific logic for onChange event
  const handleDataNameChange = (e) => {
    if (e?.target?.value || e?.target?.value === '') {
      setName(e.target.value);
    }
  }

  // Handle changes to the data name, specific logic for onBlur event
  const handleDataNameBlur = (eVal, e) => {
    const oldName = selectedNode?.NAME || '';
    
    const validationResult = validateWorkflowItemName(
      eVal, 
      oldName, 
      translatedData, 
      selectedNode?.key, 
      'SEND_DATA'
    );
    
    if (validationResult.isValid) {
      const newName = eVal?.trim() || '';
      setName(newName);
      if (newName !== oldName) {
        // Mark template as changed immediately to ensure flag is set before tab switch
        dispatch(treeActions.setTemplateChanged({ screen: parentScreen, data: true }));
        submitChange('NAME', newName);
        // Wait for debounce delay + buffer before dispatching
        setTimeout(() => {
          dispatch(treeActions.setIsInputFocusedFalse());
        }, 200);
      } else {
        // If no change, dispatch immediately
        setTimeout(() => {
          dispatch(treeActions.setIsInputFocusedFalse());
        }, 100);
      }
    } else {
      if (validationResult.errorMessage) {
        setNameErrorMessage(t(validationResult.errorMessage));
        setNameErrorModal(true);
      } else if (validationResult.shouldRevert) {
        setName(oldName);
      }
      // For error cases, dispatch immediately
      setTimeout(() => {
        dispatch(treeActions.setIsInputFocusedFalse());
      }, 100);
    }
  }
  const handleRunOnServerChange = (e) => {
    setRunOnServer(e.target.value)
    debounceChangeHandler('RUN_ON_SERVER', e.target.value)
  }

  const handleNameErrorModal = (isOpen) => {
    setNameErrorModal(isOpen);
    if (!isOpen) {
      const oldName = selectedNode?.NAME || '';
      setName(oldName);
    }
  }
  
  return (
    <Stack spacing='15px' className='tp-segment'>
      {/* Get Data Name */}
      <FormControl variant='outlined' className='width-100' size='small'>
        <InputLabel
          htmlFor='get-data-name-input'
          sx={{ padding: "0 6px !important", left: "-5px" }}
        >
          {t('COL_NAME')}
        </InputLabel>
        <OutlinedInput
          id="get-data-name-input"
          size='small'
          variant='outlined'
          fullWidth
          autoComplete='off'
          value={name}
          endAdornment={<div style={styles.getDataNameAdornment}>{`ID: ${wfItemId}`}</div>}
          sx={{ justifyContent: "flex-end" }}
          onChange={(e) => handleDataNameChange(e)}
          onBlur={(e) => handleDataNameBlur(e.target.value, e)}
          onFocus={() => dispatch(treeActions.setIsInputFocusedTrue())}
        />
      </FormControl>
      {/* Checkboxes */}
      <GetDataCheckbox selectedNode={selectedNode} updateData={debounceChangeHandler} translatedData={translatedData} /> 
      {/* Run On Server */}
      {['FILE'].includes(selectedNode?.INBOUND?.ADAPTER_TYPE) && templateHeader && templateHeader?.hasOwnProperty('SERVICE') && templateHeader?.SERVICE.NAME === selectedNode?.title && templateHeader?.SERVICE?.ENABLED === "TRUE" && (
        <FormControl>
          <InputLabel id='run-on-server'>{t('LBL_RUN_ON_SERVER')}</InputLabel>
          <Select
            size='small'
            id='run-on-server'
            value={runOnServer}
            label={t('LBL_RUN_ON_SERVER')}
            onChange={handleRunOnServerChange}
          >
            {runOnServerOptions}
          </Select>
        </FormControl>
      )}
      <FormControl size='small'>
        <InputLabel id="data-source-type-dropdown">{t('LBL_DATA_SOURCE_TYPE')}</InputLabel>
        <Select
          size='small'
          id='data-source-type-dropdown'
          value={dataSourceType}
          label={t('LBL_DATA_SOURCE_TYPE')}
          onChange={(e) => {
            setDataSourceType(e.target.value);
            debounceChangeHandler(
              null,
              null,
              {
                SOURCE_TYPE: e.target.value,
                SOURCE_WFITEM: null,
                OUTBOUND_NAME: null,
                MAPNAME: null,
                SOURCE_WFITEM_ID: null,
                CALL_WORKFLOW_ACCOUNT_ONE: null,
                CALL_WORKFLOW_ONE: null,
                CALL_WORKFLOW_GROUP_ONE: null,
                WF_ITEM_DEPENDENCY_TIMEOUT: null,
                INBOUND_NAME: null,
                SOURCE_FILE_DIRECTORY: null,
                SOURCE_FILE_MASK: null,
                SOURCE_FILE_PRESERVE_PATHS: null,
                FILE_COUNT_FILTER: null,
                SOURCE_FILE_DO_NOT_DELETE: null,
                TEMPLATE: null,
                TEMPLATE_LOCATION: null,
                FORM_DATA: null,
              },
              null,
              true
            );
          }}>
          {dataSourceTypeMenuItems}
        </Select>
      </FormControl>
      {dataSourceType !== "FORM_DATA" ? (
        <WorkflowSourceType
          node={{
            key: selectedNode?.key,
            RECORD_TYPE: selectedNode?.SOURCE_TYPE,
            WFITEM: selectedNode?.SOURCE_WFITEM,
            OUTBOUND_NAME: selectedNode?.OUTBOUND_NAME,
            MAPNAME: selectedNode?.MAPNAME,
            WF_ITEM_DEPENDENCY_TIMEOUT:
              selectedNode?.WF_ITEM_DEPENDENCY_TIMEOUT,
            WF_ITEM_ID: selectedNode?.SOURCE_WFITEM_ID,
            TEMPLATE: selectedNode?.OUTBOUND?.TEMPLATE,
            TEMPLATE_LOCATION: selectedNode?.OUTBOUND?.TEMPLATE_LOCATION,
            CALL_WORKFLOW_ACCOUNT: selectedNode?.CALL_WORKFLOW_ACCOUNT_ONE,
            CALL_WORKFLOW: selectedNode?.CALL_WORKFLOW_ONE,
            CALL_WORKFLOW_GROUP: selectedNode?.CALL_WORKFLOW_GROUP_ONE,
            WF_ITEM_LOCATION: selectedNode?.WF_ITEM_LOCATION,
            OUTBOUND_ID: selectedNode?.OUTBOUND_ID,
            SOURCE_FILE_DIRECTORY: selectedNode?.SOURCE_FILE_DIRECTORY,
            SOURCE_FILE_MASK: selectedNode?.SOURCE_FILE_MASK,
            INBOUND_NAME: selectedNode?.INBOUND_NAME,
            INBOUND_ID: selectedNode?.INBOUND_ID,
            SOURCE_FILE_PRESERVE_PATHS:
              selectedNode?.SOURCE_FILE_PRESERVE_PATHS,
            FILE_COUNT_FILTER: selectedNode?.FILE_COUNT_FILTER,
            SOURCE_FILE_DO_NOT_DELETE: selectedNode?.SOURCE_FILE_DO_NOT_DELETE,
          }}
          valuesHandler={(values) => {
            const processedValues = {
              SOURCE_TYPE: values?.RECORD_TYPE,
              SOURCE_WFITEM: values?.WFITEM,
              OUTBOUND_NAME: values?.OUTBOUND_NAME,
              MAPNAME: values?.MAPNAME,
              SOURCE_WFITEM_ID: values?.WF_ITEM_ID,
              CALL_WORKFLOW_ACCOUNT_ONE: values?.CALL_WORKFLOW_ACCOUNT,
              CALL_WORKFLOW_ONE: values?.CALL_WORKFLOW,
              CALL_WORKFLOW_GROUP_ONE: values?.CALL_WORKFLOW_GROUP,
              WF_ITEM_LOCATION: values?.WF_ITEM_LOCATION,
              WF_ITEM_ID: values?.WF_ITEM_ID,
              WFITEM: values?.WFITEM,
              WF_ITEM_DEPENDENCY_TIMEOUT: values?.WF_ITEM_DEPENDENCY_TIMEOUT,
              COMPARE: values?.COMPARE || selectedNode?.COMPARE,
              // OUTBOUND_ID: values?.OUTBOUND_ID,
              INBOUND_NAME:
                values?.RECORD_TYPE === "FORWARD_ONLY_DATA"
                  ? values?.WFITEM
                  : null,
              INBOUND_ID:
                values?.RECORD_TYPE === "FORWARD_ONLY_DATA"
                  ? values?.WF_ITEM_ID
                  : null,
              SOURCE_FILE_DIRECTORY: values?.SOURCE_FILE_DIRECTORY,
              SOURCE_FILE_MASK: values?.SOURCE_FILE_MASK,
              TEMPLATE: values?.TEMPLATE,
              TEMPLATE_LOCATION: values?.TEMPLATE_LOCATION,
              SOURCE_FILE_PRESERVE_PATHS: values?.SOURCE_FILE_PRESERVE_PATHS,
              FILE_COUNT_FILTER: values?.FILE_COUNT_FILTER,
              SOURCE_FILE_DO_NOT_DELETE: values?.SOURCE_FILE_DO_NOT_DELETE,
            };
            debounceChangeHandler(null, null, processedValues, null, true);
          }}
          onlySessionData={true}
          workflowItemLabel={t("LBL_SOURCE_WORKFLOW_ITEM")}
          sourceNameLabel={t("LBL_SOURCE_FIELD_NAME")}
        />
      ) : (
        <Accordion sx={styles.accordianContainer} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="form-data-grid"
            id="form-data-grid"
            className="accordian-override"
            sx={styles.accordianHeader}>
            <SectionHeader text={t("LBL_FORM_DATA_FIELDS")} />
          </AccordionSummary>
          <AccordionDetails sx={styles.accordianContainer}>
            <div style={{ height: 195, overflow: "hidden" }}>
              <CommonGrid
                rowData={rowData}
                gridOptions={gridOptions}
                containerStyle={{ height: 195 }}
                getGridAPI={getGridAPI}
                gridProps={{
                  animateRows: false,
                  ensureDomOrder: true,
                  suppressScrollWhenPopupsAreOpen: true,
                  suppressScrollOnNewData: true,
                  enableCellTextSelection: true,
                  suppressHorizontalScroll: true,
                  onCellValueChanged: handleCellValueChanged,
                  onCellKeyDown,
                  onRowDataUpdated: onRowDataUpdated,
                  suppressColumnVirtualisation: true,
                  tooltipShowDelay: 500,
                  enableBrowserTooltips: true,
                }}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      )}
      {/* Encoding  */}
      <FormControl>
        <InputLabel id="encoding-dropdown">{t('ENCODING')}</InputLabel>
        <Select
          size="small"
          id="encoding-dropdown"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300
              }
            }
          }}
          value={encoding}
          label={t("ENCODING")}
          onChange={(e) => {
            setEncoding(e.target.value);
            debounceChangeHandler("ENCODING", e.target.value);
          }}>
          {encodingOptions}
        </Select>
      </FormControl>
      {['FUJITSU-JAPAN', 'IBM-JAPAN', 'OI-Shift_JIS', 'ISO-2022-JP', 'EUC-JP'].includes(encoding) && (
        <>
          <FormControl>
            <TextField
              label={t('LBL_ENCODING_SINGLE_BYTE_REPLACE')}
              size="small"
              value={encodingSingleByteReplace}
              onChange={(e) => {
                setEncodingSingleByteReplace(e.target.value);
                const result = validateHexByteSequence(e.target.value);
                if (result === true) {
                  debounceChangeHandler(
                    'ENCODE_REPLACE_WITH',
                    e.target.value
                  );
                }
              }}
              onBlur={(e) => {
                const value = e.target.value;
                const result = validateHexByteSequence(value);
                if (result !== true) {
                  setErrorMsg(t('BOX_REPLACE_SINGLE_BYTE_INVALID'));
                  setShowError(true);
                  setFieldToReset('single');
                  // Do NOT reset value here!
                }
              }}
            />
          </FormControl>
          <FormControl>
            <TextField
              label={t('LBL_ENCODING_DOUBLE_BYTE_REPLACE')}
              size="small"
              value={encodingDoubleByteReplace}
              onChange={(e) => {
                setEncodingDoubleByteReplace(e.target.value);
                const result = validateHexByteSequence(e.target.value);
                if (result === true) {
                  debounceChangeHandler(
                    'ENCODE_REPLACE_WITH_KANJI',
                    e.target.value
                  );
                }
              }}
              onBlur={(e) => {
                const value = e.target.value;
                const result = validateHexByteSequence(value);
                if (result !== true) {
                  setErrorMsg(t('BOX_REPLACE_DOUBLE_BYTE_INVALID'));
                  setShowError(true);
                  setFieldToReset('double');
                  // Do NOT reset value here!
                }
              }}
            />
          </FormControl>
        </>
      )}
      {/* Connection details */}
      {Object.keys(connectionInfo).length > 0 && (
        <Accordion sx={styles.accordianContainer} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="connection-info"
            id="connection-info"
            className="accordian-override"
            sx={styles.accordianHeader}>
            <SectionHeader text="Connection Details" />
          </AccordionSummary>
          <AccordionDetails sx={styles.accordianContainer}>
            <WorkflowConnectionPanel
              screen="SEND_DATA"
              node={selectedNode}
              connectionDetails={connectionInfo}
              handleConnectionDetailsChange={handleConnectionDetailsChange}
            />
          </AccordionDetails>
        </Accordion>
      )}
      {/* Error Modal for encoding validation */}
      <ErrorModal
        errorModal={showError}
        setErrorModal={setShowError}
        errorMessage={errorMsg ? errorMsg.replace(/\\n/g, '\n') : ''}
        errorType={t('ERROR')}
        OkHandler={() => {
          setShowError(false);
          if (fieldToReset === 'single') {
            setEncodingSingleByteReplace(selectedNode?.OUTBOUND?.ENCODE_REPLACE_WITH || '');
          } else if (fieldToReset === 'double') {
            setEncodingDoubleByteReplace(selectedNode?.OUTBOUND?.ENCODE_REPLACE_WITH_KANJI || '');
          }
          setFieldToReset(null);
        }}
      />
      {/* Error Modal for name validation */}
      <ErrorModal
        errorModal={nameErrorModal}
        setErrorModal={setNameErrorModal}
        errorMessage={nameErrorMessage}
        errorType={t('ERROR')}
        handleErrorModal={handleNameErrorModal}
      />
    </Stack>
  );
}

export default SendDataProperties

/**
 * A map of adapter types to their corresponding configuration keys.
 * This object is used to determine which keys should be updated in the "INBOUND" object
 * based on the adapter type.
 *
 * Example:
 * - `BridgeGateSocket` includes configuration options like `PORT`, `EOD_TERMINATOR`, and others
 *   that are specific to this adapter.
**/
const adapterBasedKeysMap = {
  BridgeGateSocket: [
    'PORT',
    'EOD_TERMINATOR',
    'TIMEOUT',
    'KEEP_ALIVE',
    'USE_SINGLE_CONN',
    'SSL',
    'PREDEFINED',
    'ENCODING',
    'USE_WSDL',
    'ADAPTER_TYPE',
    'ENCODE_REPLACE_WITH',
    'ENCODE_REPLACE_WITH_KANJI',
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
  ],
  DATABASE: [
    'ADAPTER_TYPE',
    'DATABASE_TYPE',
    'JDBCURL',
    'USERNAME',
    'PASSWORD',
    'ENCODING',
    'DB_WRITE_THREADS',
    'TRANSACTION_TYPE',
    'ENCODE_REPLACE_WITH',
    'ENCODE_REPLACE_WITH_KANJI',
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
  ],
  FILE: [
    "ADAPTER_TYPE",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "PREDEFINED",
    "FILE_LOCATION",
    "FILENAME",
    "COMPRESSION_TYPE",
    "FILE_NAME_WITHIN_ZIP",
    "APPEND_FILE",
    "USE_ZIP_PASSWORD",
    "ZIP_PASSWORD",
    "ZIP",
    "ENCODING",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  BridgeGateHTTP: [
    "ADAPTER_TYPE",
    "AUTHENTICATE",
    "BTN_SEND_SYNC_RESPONSE",
    "DONT_RETAIN_PLAIN_TEXT",
    "DO_NOT_PROCESS_DUPLICATE_FILES",
    "ENCODING",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "ENCRYPTION_TYPE",
    "REC_POST_DATA",
    "USE_WSDL",
    "USE_ZIP_PASSWORD",
    "ZIP",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI",
    // Basic Auth keys
    "USERNAME",
    "PASSWORD",
    // Bearer Token key
    "TOKEN_NAME",
    // OAuth 2.0 keys
    "OAUTH2_TOKEN",
    "OAUTH2_HEADER_PREFIX",
    "OAUTH2_AUTO_REFRESH_TOKEN",
    "OAUTH2_ADD_TO",
    "OAUTH2_GRANT_TYPE",
    "OAUTH2_ACCESS_TOKEN_URL",
    "OAUTH2_CLIENT_ID",
    "OAUTH2_CLIENT_SECRET",
    "OAUTH2_USERNAME",
    "OAUTH2_PASSWORD",
    "OAUTH2_CLIENT_AUTHENTICATION",
    "OAUTH2_REFRESH_TOKEN_URL"
  ],
  BridgeGateFTP: [
    "ADAPTER_TYPE",
    "ENCODING",
    "PREDEFINED",
    "DELETE",
    "SSH",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "FILE_LOCATION",
    "FILENAMEMASK",
    "ACCOUNT",
    "TRADING_PARTNER_NAME",
    "SPECIFY_DECOMPRESSION_DIRECTORY",
    "DECOMPRESSION_DIRECTORY",
    "USE_ZIP_PASSWORD",
    "ZIP_PASSWORD",
    "ZIP",
    "FILENAME",
    "FILE_NAME_WITHIN_ZIP",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  SSH: [
    "ADAPTER_TYPE",
    "CONNECTIONSTRING",
    "USERNAME",
    "PASSWORD",
    "SSH_SCRIPT",
    "ENCODING",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "KEY",
    "KEY_PASSWORD",
    "GUARANTY_DELIVERY",
    "ALERT",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  "Data Stream": [
    "ADAPTER_TYPE",
    "DO_NOT_PROCESS_DUPLICATE_FILES",
    "TIME_BEFORE_RETRY",
    "FILETIME_FILTER",
    "FILETIME_FILTER_MAX",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "RETRY_COUNT",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "ENCODING",
    "USE_CALL_WF_FOR_DATASTREAM",
    "CWF_WF_GROUP",
    "CWF_WORKFLOW",
    "CWF_ACCOUNT",
    "CWF_RUN_CONCURRENT",
    "CWF_RUN_DISTRIBUTED",
    "CWF_MAX_CONCURRENT_THREADS",
    "CWF_IGNORE_ERRORS",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  "Synchronous Response": [
    "TIMEOUT",
    "EOD_TERMINATOR",
    "ADAPTER_TYPE",
    "DO_NOT_PROCESS_DUPLICATE_FILES",
    "FILETIME_FILTER",
    "FILETIME_FILTER_MAX",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "ENCODING",
    "HTTP_RESPONSE_CODE",
    "HTTP_CONTENT_TYPE",
    "OVERRIDE_HTTP_RESPONSE_CODE",
    "OVERRIDE_HTTP_CONTENT_TYPE",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI",
    "GUARANTY_DELIVERY",
    "ALERT",
    "ERROR_HANDLER_ID",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
  ],
  AS2: [
    "ADAPTER_TYPE",
    "ENCODING",
    "TIME_BEFORE_RETRY",
    "RETRY_COUNT",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "AS2_COMPRESSION",
    "AS2_ENC_ALG",
    "AS2_ID",
    "AS2_MDN_SECURITY",
    "AS2_MDN_TRANSPORT",
    "AS2_MDN_URL",
    "AS2_SECURITY",
    "AS2_SIG_ALG",
    "AS2_TRANSPORT",
    "AS2_URL",
    "EMAIL",
    "SENDER_AS2_ID",
    "X509_ALIAS_ENCRYPTION",
    "X509_ALIAS_HTTPS",
    "X509_ALIAS_SIGNING",
    "NAME",
    "AS2_FILE_NAME",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  "Web Service": [
    "ADAPTER_TYPE",
    "USE_WSDL",
    "WSDL_PATH",
    "WSDL_CACHED",
    "ARGS",
    "WSDL_POLICY_CACHED",
    "WSDL_BINDING",
    "WSDL_BINDING_OPERATION",
    "WSDL_BINDING_SERVICE",
    "CONNECTIONSTRING",
    "TARGET_NAMESPACE",
    "REQUEST_ELEMENT_NAME",
    "SOAP_ACTION",
    "SOAP_PREFIX",
    "AUTHENTICATE",
    "USERNAME",
    "PASSWORD",
    "REALM",
    "TIMEOUT",
    "KEY_ALIAS",
    "SSL_TYPE",
    "WRITE_SOAP_BODY",
    "MAINTAIN_SESSION",
    "HTTP_CUSTOM_HEADER_FIELDS",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "SYNCHRONOUS",
    "SEND_SOURCE_AS_SOAP_BODY",
    "DISABLE_CHUNKED_DATA",
    "QOS_HTTP_CODES",
    "GUARANTY_DELIVERY",
    "ALERT",
    "ERROR_HANDLER_ID",
    // WS_SECURITY specific keys
    "POLICY",
    "KEYSTORE",
    "KEYSTORE_PWD",
    "KEYSTORE_TYPE",
    "PRIVATE_KEY_PWD",
    "USER_CERT_ALIAS",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI",
    // Bearer Token key
    "TOKEN_NAME",
    // OAuth 2.0 keys
    "OAUTH2_TOKEN",
    "OAUTH2_HEADER_PREFIX",
    "OAUTH2_AUTO_REFRESH_TOKEN",
    "OAUTH2_ADD_TO",
    "OAUTH2_GRANT_TYPE",
    "OAUTH2_ACCESS_TOKEN_URL",
    "OAUTH2_CLIENT_ID",
    "OAUTH2_CLIENT_SECRET",
    "OAUTH2_USERNAME",
    "OAUTH2_PASSWORD",
    "OAUTH2_CLIENT_AUTHENTICATION",
    "OAUTH2_REFRESH_TOKEN_URL"
  ],
  BridgeGateWebService: [
    "ADAPTER_TYPE",
    "CONNECTIONSTRING",
    "SERVICE_NAME",
    "TARGET_NAMESPACE",
    "AUTHENTICATE",
    "USERNAME",
    "PASSWORD",
    "SOAP_USE_ENVELOPE_AS_RESULT",
    "WRITE_SOAP_BODY",
    "SEND_SOURCE_AS_SOAP_BODY",
    "SYNCHRONOUS",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "GUARANTY_DELIVERY",
    "ALERT",
    "ERROR_HANDLER_ID",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  EMAIL: [
    "ADAPTER_TYPE",
    "ENCODING",
    "TIME_BEFORE_RETRY",
    "RETRY_COUNT",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "SSL",
    "PORT",
    "TLS",
    "USERNAME",
    "AUTH_TYPE",
    "FILE_NAME_WITHIN_ZIP",
    "PASSWORD",
    "SPECIFY_DECOMPRESSION_DIRECTORY",
    "USE_ZIP_PASSWORD",
    "ZIP_PASSWORD",
    "ZIP",
    // SEND_DATA specific keys
    "CONNECTIONSTRING",
    "TO_EMAIL",
    "FROM_EMAIL",
    "CC_EMAIL",
    "BCC_EMAIL",
    "SUBJECT",
    "MESSAGE_ID",
    "OUTPUT_AS_ATTACHMENT",
    "FILENAME",
    "REQUIRES_AUTHENTICATION",
    "COMPRESSION",
    "COMPRESSION_TYPE",
    "FILE_NAME_WITHIN_ZIP",
    "BODY",
    "HTML_CONTENT",
    "PREDEFINED",
    "CREDENTIALS_JSON",
    "REFRESH_TOKEN",
    // Enhanced QOS keys
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "MAIL_TYPE",
    "TENANT_ID",
    "CLIENT_ID",
    "CLIENT_SECRET",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
    ],
  SOCKET: [
    "CONNECTIONSTRING",
    "PORT",
    "KEEP_ALIVE",
    "TIMEOUT",
    "EOD_TERMINATOR",
    "ADAPTER_TYPE",
    "ENCODING",
    "TIME_BEFORE_RETRY",
    "RETRY_COUNT",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "PREDEFINED",
    "SSL",
    "KEY_ALIAS",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "ERROR_HANDLER_ID",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ALERT",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  FTP: [
    "PREDEFINED",
    "ADAPTER_TYPE",
    "ENCODING",
    "TIME_BEFORE_RETRY",
    "RETRY_COUNT",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "CONNECTIONSTRING",
    "ACCOUNT",
    "FILENAME",
    "FILE_NAME_WITHIN_ZIP",
    "FILENAMEMASK",
    "FILE_LOCATION",
    "PASSWORD",
    "USERNAME",
    "FILENAME",
    "DECOMPRESSION_DIRECTORY",
    "USE_ZIP_PASSWORD",
    "ZIP_PASSWORD",
    "ZIP",
    "BATCH_DOWNLOAD_LOC",
    "BATCH_MODE",
    "DELETE",
    "ASCII",
    "CACHE_CONNECTION",
    "PASSIVE_MODE",
    "DO_NOT_PROCESS_DUPLICATE_FILES",
    "POST_FTP_SCRIPT",
    "PRE_FTP_SCRIPT",
    "KEY",
    "KEY_PASSWORD",
    "SSL",
    "SSL_STRATEGY",
    "SSH",
    "TEMPLATE_LOCATION",
    "TEMPLATE",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",  
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  "Command Prompt": [
    "CMD",
    "ADAPTER_TYPE",
    "CMD_ARGS",
    "FILENAME",
    "STREAM_ARGS",
    "STREAM_DATA",
    "ZIP",
    "COMPRESSION",
    "COMPRESSION_TYPE",
    "FILE_NAME_WITHIN_ZIP",
    "SPECIFY_DECOMPRESSION_DIRECTORY",
    "DECOMPRESSION_DIRECTORY",
    "USE_ZIP_PASSWORD",
    "ZIP_PASSWORD",
    "SCRIPT",
    "ENCODING",
    "PREDEFINED",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "DONT_RETAIN_PLAIN_TEXT",
    "ALERT",
    "ERROR_HANDLER_ID",
    "GUARANTY_DELIVERY",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  AmazonSQS: [
    "ADAPTER_TYPE",
    "URL",
    "ACCESS_KEY_ID",
    "SECRET_KEY_ID",
    "TIMEOUT",
    "DURABLE_SUBSCRIPTION_CLIENT_ID",
    "MESSAGE_GROUP_ID",
    "ENCODING",
    "PREDEFINED",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "DONT_RETAIN_PLAIN_TEXT",
    "ALERT",
    "ERROR_HANDLER_ID",
    "GUARANTY_DELIVERY",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI",
  ],
  Kafka: [
    "PREDEFINED",
    "ADAPTER_TYPE",
    "TOPIC_NAME",
    "BOOTSTRAP_SERVERS_CONFIG",
    "CLIENT_ID_CONFIG",
    "KEY_SERIALIZER_CLASS_CONFIG",
    "VALUE_SERIALIZER_CLASS_CONFIG",
    "AUTH_TYPE",
    "USERNAME",
    "PASSWORD",
    "SSL_TYPE",
    "KEYSTORE",
    "KEYSTORE_PWD",
    "KEY_PWD",
    "TRUSTSTORE",
    "TRUSTSTORE_PWD",
    "DISABLE_QOS",
    "QUALITY_OF_SERVICE_1",
    "QUALITY_OF_SERVICE_2",
    "QUALITY_OF_SERVICE_3",
    "QUALITY_OF_SERVICE_4",
    "DON_T_USE_ENCRYPTION",
    "USE_ENCRYPTION",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "ENCRYPTION_KEY",
    "ZIP",
    "COMPRESSION",
    "COMPRESSION_TYPE",
    "FILE_NAME_WITHIN_ZIP",
    "SPECIFY_DECOMPRESSION_DIRECTORY",
    "DECOMPRESSION_DIRECTORY",
    "USE_ZIP_PASSWORD",
    "ZIP_PASSWORD",
    "SCRIPT",
    "ENCODING",
    "PREDEFINED",
    "OVERRIDE",
    "AUTH_TYPE",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI",
    "GUARANTY_DELIVERY",
    "ALERT",
    "ERROR_HANDLER_ID",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
  ],
  
  HTTP: [
    "ADAPTER_TYPE",
    "CONNECTIONSTRING",
    "USERNAME",
    "PASSWORD",
    "KEY_ALIAS",
    "HTTP_TIMEOUT",
    "URLENCODE",
    "FORCE_HOST_VERIFICATION",
    "SYNCHRONOUS",
    "SSL_TYPE",
    "REQUEST_TYPE",
    "CONTENT_TYPE",
    "SOAP_ACTION",
    "ZIP",
    "FILE_NAME_WITHIN_ZIP",
    "ZIP_PASSWORD",
    "USE_ZIP_PASSWORD",
    "DECOMPRESSION_DIRECTORY",
    "SPECIFY_DECOMPRESSION_DIRECTORY",
    "HTTP_CUSTOM_HEADER_FIELDS",
    "COMPRESSION",
    "COMPRESSION_TYPE",
    "ENCODING",
    "RETRY_COUNT",
    "QOS_HTTP_CODES",
    "TIME_BEFORE_RETRY",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "GUARANTY_DELIVERY",
    "ALERT",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI",
    "FORM_DATA",
    "AUTHENTICATE",
    "HTTP_QUERY_PARAMETERS",
    "TOKEN_NAME",
  ],
  ActiveMQ: [
    "ADAPTER_TYPE",
    "PREDEFINED",
    "TIMEOUT",
    "INIT_URL",
    "DESTINATION_TYPE",
    "QUEUE_OR_TOPIC_NAME",
    "DURABLE_SUBSCRIPTION_CLIENT_ID",
    "ENCODING",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  "MQ Series": [
    "ADAPTER_TYPE",
    "CONNECTION_FACTORY_LOOKUP",
    "DESTINATION_TYPE",
    "QUEUE_OR_TOPIC_NAME",
    "DURABLE_SUBSCRIPTION_CLIENT_ID",
    "HOST_NAME",
    "PORT",
    "USERNAME",
    "PASSWORD",
    "CHANNEL",
    "TRANSACTIONAL",
    "SSL",
    "CIPHER",
    "RUN_ON_PRIMARY",
    "ENCODING",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    // MQ Series Header Fields
    "CCSID",
    "REPLYTO_QUEUENAME",
    "MQ_ENCODING",
    "REPLYTO_QUEUEMANAGERNAME",
    "EXPIRY",
    "USER_ID",
    "PERSISTENCE",
    "ACCOUNTING_TOKEN",
    "PRIORITY",
    "APPLICATION_ID_DATA",
    "TARGET_CLIENT",
    "PUT_APPLICATION_NAME",
    "VERSION",
    "PUT_DATE_TIME",
    "REPORT",
    "APPLICATION_ORIGIN_DATA",
    "MESSAGE_TYPE",
    "GROUP_ID",
    "FEEDBACK",
    "MESSAGE_SEQ_NUM",
    "FORMAT",
    "OFFSET",
    "BACKOUT_COUNT",
    "MESSAGE_FLAGS",
    "ORIGINAL_LENGTH",
    "CORRELATION_ID",
    "CORRELATION_ID_HEX",
    "MESSAGE_ID",
    "MESSAGE_ID_HEX",
    "APP_DEFINED_HEADER_FIELDS",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  Azure: [
    "ADAPTER_TYPE",
    "PREDEFINED",
    "AZURE_ACCOUNT_NAME",
    "AZURE_ACCOUNT_KEY",
    "AZURE_FILESYSTEM",
    "CREATE_FILESYS",
    "AZURE_DIRECTORY",
    "CREATE_DIRS",
    "AZURE_FILENAME",
    "DELETE",
    "APPEND_FILE",
    "ENCODING",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  MSMQ: [
    "ADAPTER_TYPE",
    "PREDEFINED",
    "PRIVATE_PUBLIC",
    "QUEUE_NAME",
    "URL",
    "DOMAIN",
    "USERNAME",
    "PASSWORD",
    "useNTLMv1",
    "NTLMv2",
    "DEADLETTER",
    "TRANSACTIONAL",
    "MSMQ_AUTOCOMMIT",
    "ENCODING",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ACK",
    "APPSPECIFIC",
    "AUTHLEVEL",
    "DELIVERY",
    "JOURNAL",
    "LABEL",
    "MAXTIMETOREACHQUEUE",
    "MAXTIMETORECEIVE",
    "PRIORITY",
    "PRIVLEVEL",
    "TRACE",
    "HASHALGORITHM",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  GraphQL: [
    "ADAPTER_TYPE",
    "CONNECTIONSTRING",
    "USERNAME",
    "PASSWORD",
    "KEY_ALIAS",
    "HTTP_TIMEOUT",
    "URLENCODE",
    "FORCE_HOST_VERIFICATION",
    "SYNCHRONOUS",
    "SSL_TYPE",
    "REQUEST_TYPE",
    "CONTENT_TYPE",
    "ZIP",
    "FILE_NAME_WITHIN_ZIP",
    "ZIP_PASSWORD",
    "USE_ZIP_PASSWORD",
    "DECOMPRESSION_DIRECTORY",
    "SPECIFY_DECOMPRESSION_DIRECTORY",
    "HTTP_CUSTOM_HEADER_FIELDS",
    "COMPRESSION",
    "COMPRESSION_TYPE",
    "ENCODING",
    "RETRY_COUNT",
    "QOS_HTTP_CODES",
    "TIME_BEFORE_RETRY",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "GUARANTY_DELIVERY",
    "ALERT",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI",    
  ],
  JMS: [
    "ADAPTER_TYPE",
    "CONNECTION_FACTORY_LOOKUP",
    "CTX_FACTORY",
    "INIT_URL",
    "DESTINATION_TYPE",
    "QUEUE_OR_TOPIC_NAME",
    "DURABLE_SUBSCRIPTION_CLIENT_ID",
    "USERNAME",
    "PASSWORD",
    "ENCODING",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "ALERT",
    "GUARANTY_DELIVERY",
    "ERROR_HANDLER_ID",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
  "Google Cloud Storage": [
    "ADAPTER_TYPE",
    "PREDEFINED",
    "OAUTH_REDIRECT_URL",
    "CLIENT_ID",
    "CLIENT_SECRET",
    "PROJECT_ID",
    "CREDENTIALS_JSON",
    "BUCKET_NAME",
    "OBJECT_NAME",
    "RETURN_DATA",
    "DELETE",
    "ENCODING",
    "DONT_RETAIN_PLAIN_TEXT",
    "ENCRYPTION_TYPE",
    "ENCRYPTION_PARAM1",
    "ENCRYPTION_PARAM_PGP",
    "FILENAME_WITHIN_ENC",
    "RETRY_COUNT",
    "TIME_BEFORE_RETRY",
    "ALERT",
    "ERROR_HANDLER_ID",
    "GUARANTY_DELIVERY",
    "ZIP",
    "COMPRESSION",
    "COMPRESSION_TYPE",
    "FILE_NAME_WITHIN_ZIP",
    "ENCODE_REPLACE_WITH",
    "ENCODE_REPLACE_WITH_KANJI"
  ],
};

export { adapterBasedKeysMap };

// Additional properties to be added based on the adapter type. used in the submitChange function when the ADAPTER_TYPE value is changed
export const adapterTypeAdditionalProperties = {
  BridgeGateFTP: {
    USE_WSDL: "FALSE",
  },
  BridgeGateHTTP: {
    AUTHENTICATE: "TRUE",
    REC_POST_DATA: "FALSE",
    USE_WSDL: "FALSE",
  },
  SOCKET: {
    USE_WSDL: "FALSE",
    KEEP_ALIVE: "FALSE",
    SSL: "FALSE",
  },
  "Web Service": {
    USE_WSDL: "FALSE",
    MAINTAIN_SESSION: "FALSE",
    TIMEOUT: "30",
    SSL_TYPE: "TLSv1",
  },
  FTP: {
    ASCII: "FALSE",
    CACHE_CONNECTION: "TRUE",
    PASSIVE_MODE: "FALSE",
    USE_WSDL: "FALSE",
    CREATE_DIRS: "TRUE",
  },

  HTTP: {
    URLENCODE: "TRUE",
    SSL_TYPE: "TLSv1.2",
    REQUEST_TYPE: "GET",
  },
  ActiveMQ: {
    DESTINATION_TYPE: "QUEUE"
  },
  "MQ Series": {
    CHANNEL: "SYSTEM.DEF.SVRCONN"
  },
  Azure: {
    APPEND_FILE: "FALSE",
    CREATE_FILESYS: "TRUE",
    CREATE_DIRS: "TRUE",
  },
  MSMQ: {
    PRIVATE_PUBLIC: "PRIVATE",
    DEADLETTER: "FALSE",
    TRANSACTIONAL: "FALSE",
    MSMQ_AUTOCOMMIT: "TRUE",
  },
  GraphQL: {
    REQUEST_TYPE: "POST",
    CONTENT_TYPE: "application/json",
    SSL_TYPE : "TLSv1",
  },
};

const styles = {
  accordianContainer: {
    border: "none",
    padding: "0",
    margin: "0",
    boxShadow: "none",
    backgroundColor: "unset",
  },
  accordianHeader: {
    border: "none",
    padding: "0",
    margin: "0",
    backgroundColor: "unset",
  },
  accordianContent: {
    border: "none",
    padding: "0 15px",
    margin: "0",
    backgroundColor: "unset",
  },
  getDataNameAdornment: {
    color: "#666666",
    fontSize: "9px",
    position: "absolute",
    right: "13px",
    top: "-6px",
    backgroundColor: "#FFF",
    zIndex: "2",
    padding: "0 5px",
    height: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }
};
